import React from "react"
import { FormRow, FlatContentBox } from "src/components/Grid"

export default function FormBox({ children, ...props }) {
  return (
    <FormRow {...props} flex>
      <FlatContentBox
        flex
        column
        style={{
          flexGrow: 1,
        }}
      >
        {children}
      </FlatContentBox>
    </FormRow>
  )
}
